module.exports = __webpack_public_path__ + "img/loader.83d3513.png";